import Vue from 'vue'
import Vuex from 'vuex'
const version = require('../../version.json')

Vue.use(Vuex)

const state = {
  version: version.tag,
  connected: null,
  connectedAt: null,
  disconnectedAt: null,
  updatedAt: null,
  thresh: {
    life: [70, 90],
    vib: [1.2, 1.5],
    temp: [35, 40]
  },
  level: {
    life: 0,
    vib: 0,
    temp: 0
  },
  currentLevel: null,
  history: {
    life: [],
    vib: [],
    temp: []
  },
  totalPoints: 20,
  colors: {
    light: '#f5f5f7',
    dark: '#333b40',
    secondary: '#cdc7c5',
    primary: '#f29000',
    info: '#0070e0',
    warning: '#ffff66',
    success: '#8ffbaf',
    danger: '#db3645',
    darkinfo: '#24406b',
    darksuccess: '#009303',
    darkdanger: '#a1210a',
    darkwarning: '#ffcb00',
    darkgrey: '#cdc7c5'
  }
}

const getters = {
  connected (state) {
    return state.connected
  },
  version (state) {
    return state.version
  },
  colors (state) {
    return state.colors
  },
  levelColors (state) {
    return [state.colors.success, state.colors.warning, state.colors.danger]
  },
  thresh (state) {
    return state.thresh
  },
  history (state) {
    return state.history
  },
  totalPoints (state) {
    return state.totalPoints
  },
  currentLife (state) {
    return state.history.life.slice(-1)[0]
  },
  currentVib (state) {
    const lastElement = state.history.vib.slice(-1)[0]
    return lastElement && lastElement.y
  },
  currentLevel (state) {
    return state.currentLevel
  },
  level (state) {
    return state.level
  }
}

const mutations = {
  setConnected (state, payload) {
    state.connected = payload
  },
  updateHistory (state, payload) {
    state.history[payload.tag].push(payload.point)
    Vue.set(state.history, payload.tag, state.history[payload.tag].slice(-state.totalPoints))

    const thresh = state.thresh[payload.tag]

    let level = 0
    if (payload.point.y > thresh[1]) {
      level = 2
    } else if (payload.point.y > thresh[0]) {
      level = 1
    }

    Vue.set(state.level, payload.tag, level)
    Vue.set(state, 'currentLevel', Math.max(state.level.life, state.level.vib, state.level.temp))
  },
  updateLife (state, payload) {
    let scl = 1.0

    const currentLife = payload.currentLife || 0
    const currentVib = payload.currentVib || 0
    const thresh = state.thresh.life

    let level = 0
    if (currentLife > thresh[1]) {
      level = 2
      scl = 2.0
    } else if (currentLife > thresh[0]) {
      level = 1
      scl = 1.5
    }

    Vue.set(state.level, 'life', level)
    Vue.set(state, 'currentLevel', Math.max(state.level.life, state.level.vib, state.level.temp))

    let newLife = currentLife + scl * Math.pow(currentVib, 2)
    if (newLife > 120) {
      newLife = 0
    }

    state.history.life.push(newLife)
    Vue.set(state.history, 'life', state.history.life.slice(-state.totalPoints))
  }
}

const actions = {}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js